<script setup lang="ts">
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import KBtn from '@/components/btns/KBtn.vue';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';

export interface Props {
  article: openapi.Article | undefined;
  isLoading: boolean;
  isFetchingUpvoteArticle: boolean;
  isFetchingDownvoteArticle: boolean;
  upvoteArticle: (id: number) => Promise<void>;
  downvoteArticle: (id: number) => Promise<void>;
}
const props = withDefaults(defineProps<Props>(), {
  article: undefined,
  isLoading: false,
});
</script>

<template>
  <div
    :class="$style.helpcenterSideBarArticleCard"
    data-testid="helpcenterSideBarArticleCard"
  >
    <template v-if="props.isLoading">
      <SimpleLoader :size="64" :width="6" class="my-8" />
    </template>
    <template v-else-if="props.article">
      <h4 :class="$style.h4">{{ props.article.title }}</h4>
      <!-- eslint-disable vue/no-v-html -->
      <article :class="$style.article" v-html="props.article.content"></article>
      <!-- eslint-enable vue/no-v-html -->

      <div :class="$style.buttons" class="mt-4">
        <div>Was this helpful?</div>
        <div class="ml-3">
          <KBtn
            size="xs"
            variant="text"
            :loading="props.isFetchingUpvoteArticle"
            @click="props.upvoteArticle(props.article.id)"
          >
            Yes
          </KBtn>
          <KBtn
            size="xs"
            variant="text"
            :loading="props.isFetchingDownvoteArticle"
            @click="props.downvoteArticle(props.article.id)"
          >
            No
          </KBtn>
        </div>
      </div>
    </template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.helpcenterSideBarArticleCard {
}
  .h4 {
    font-weight: 500;
  }
  .buttons {
    font-size: 14px;
    line-height: 1.4;
    color: colors.$color-text-secondary;
    display: flex;
    align-items: center;
  }
  .article {
    img {
      max-width: 100%;
    }
  }
</style>
